import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import {
  ColorValues,
  Flex,
  IconBrandIconToday,
  Typography,
} from '@banhala/ui-kit';

export const DeliveryLeadDays: React.FC<{ review: GoodsReview }> = props => {
  return (
    <Flex
      backgroundColorValue={ColorValues.blue5}
      padding={{ vertical: 8, horizontal: 12 }}
      borderRadius={50}
    >
      {props.review.delivery_lead_days < 2 ? (
        <Flex.Row alignItems={'center'}>
          <IconBrandIconToday color={ColorValues.lilac40} />
          <Flex margin={{ top: 2 }}>
            <Typography type={'subtitle3'} color={'bg_slate_primary'}>
              로 발송되었어요 📦
            </Typography>
          </Flex>
        </Flex.Row>
      ) : (
        <Typography type={'subtitle3'} color={'bg_slate_primary'}>
          {props.review.delivery_lead_days}일 후 발송되었어요 📦
        </Typography>
      )}
    </Flex>
  );
};
